import Image from 'core/display/Image'
import { enableTap } from 'core/handlers/TapHandler'
import { ButtonManager } from 'managers/ButtonManager'
import { KeyboardManager } from 'managers/KeyboardManager'
import { signal } from 'services/SignalsService'

export default class ToggleButton {
  constructor(data) {
    this.self = new Image(data)
    this.self.calculateGlow()
    this.images = this.self.images
    this.id = `TOGGLE:${data.name}`
    this.state = true

    this.createSignal()

    KeyboardManager.register({ id: this.id, tap: this.tap.bind(this) })
    enableTap(this.self, this.tap.bind(this))

    return this.self
  }

  createSignal(){
    const self = this

    signal.on(self.id, function (value) {
      self.state = value
      self.images[0].visible = !value
      self.images[1].visible = value
    })
  }

  tap(){
    ButtonManager.dispatch(this.id, !this.state)
  }
}
